import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import realstore from '../assets/project_img/Realstore-ecommerce.png'
import twitter from '../assets/project_img/Twitter-Clone.png'
import youtube from '../assets/project_img/youtube-clone.png'
import beminimalist from '../assets/project_img/Beminimalist-clone.png'
import { Swiper, SwiperSlide } from "swiper/react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// skills
import html from '../assets/tech_img/html.svg'
import css from '../assets/tech_img/css3.svg'
import js from '../assets/tech_img/javascript.svg'
import ts from '../assets/tech_img/typescript.svg'
import react from '../assets/tech_img/react.svg'
import redux from '../assets/tech_img/redux.svg'
import node from '../assets/tech_img/nodejs.svg'
import express from '../assets/tech_img/express.svg'
import mongo from '../assets/tech_img/mongodb.svg'
import socket from '../assets/tech_img/socket.svg'
import mui from '../assets/tech_img/material-ui-1.svg'
import chakraui from '../assets/tech_img/icons8-chakra-ui.svg'
import netlify from '../assets/tech_img/netlify.svg'
import heroku from '../assets/tech_img/heroku.svg'
import aws from '../assets/tech_img/amazon-aws.svg'

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
import SingleProject from './SingleProject'
import AOS from "aos";
import "aos/dist/aos.css";

const ProjectStyles = styled.section`
    .container{

        .projects__container{
            overflow: initial;

            .projects__content{
                display: grid;
                justify-content: center;
                transition: all 0.3s;
                padding: 1rem;

                &:hover{
                    background-color: #bebebe3f;
                    border-radius: 10px;
                }
            }
            .swiper-button-prev::after,.swiper-button-next::after{
                /* content: ''; */
                font-size: medium;
                font-weight: bolder;

            }
            .swiper-button-prev,.swiper-button-next{
                width: initial;
                height: initial;
                margin: initial;
                font-size: 2.5rem;
                color: var(--title-color);
            }
            .swiper-button-prev{
                left: 1rem;
                top: 25%;
                /* top: 5rem; */
            }
            .swiper-button-next{
                right: 1rem;
                top: 25%;
            }
            .swiper-slide{
                margin-bottom: 4.5rem;
            }
            .swiper-pagination-bullets{
                bottom: 0;
            }
            .swiper-pagination-bullet{
                background-color: var(--text-color-light);
                opacity: initial;
            }
            .swiper-pagination-bullet-active{
                background-color: var(--title-color);
            }
        }
    }
    @media screen and (max-width: 340px){
        .container{
          margin-inline: 1rem;
            .projects__container{
                .swiper-button-prev::after,.swiper-button-next::after{
                    font-size: small;
                    font-weight: bold;

                }
                .swiper-button-prev,.swiper-button-next{
                    font-size: 2rem;
                }
                .swiper-button-prev{
                    left: 0.5rem;
                    top: 20%;
                    /* top: 5rem; */
                }
                .swiper-button-next{
                    right: 0.5rem;
                    top: 20%;
                }
                .swiper-slide{
                    margin-bottom: 3rem;
                }
            }
        }
    }

    @media screen and (min-width: 576px){
        .container{
            .projects__container{
                width: 400px;
                overflow: hidden;

                .swiper-button-prev{
                    left: 1rem;
                }
                .swiper-button-next{
                    right: 1rem;
                }
            }
        }
    }
    @media screen and (min-width: 767px){
        .container{
            .projects__container{
                width: 600px;
            }
        }
    }

    @media screen and (min-width: 1048px){
        .container{
            margin-inline: auto;
        }
    }
    @media screen and (min-width: 1200px){
        .container{
            .projects__container{
                width: 1100px;
                .projects__content{
                    margin-bottom: 6.5rem;
                    
                }
                .swiper-button-prev::after,
                .swiper-button-next::after{
                    font-size: 1.5rem;
                }
                .swiper-button-prev::after{
                    left: 1rem;
                }
                .swiper-button-next::after{
                    right: 1rem;
                }
            }
        }
    }
    
`

function Project({ menuref }) {

    const currref = useRef(null);

    const scrollActive = () => {
        const scrollY = window.pageYOffset;
        const sectionHeight = currref.current.offsetHeight;
        const sectionTop = currref.current.offsetTop - 58;
        // console.log(currref.current.id);
        const sectionId = currref.current.id;
        const sectionClass = menuref.current.querySelector('.nav__menu a[href*=' + sectionId + ']');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionClass.classList.add('active-link');
        } else {
            sectionClass.classList.remove('active-link');
        }

    }
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [pimg, setPimg] = useState();
    const [stacks, setStacks] = useState([]);
    const [links, setLinks] = useState({ demo: "", github: "" });


    const projects = [
        {
            name: "RealStore Website",
            subtitle: "Ecommerce",
            heroimg: realstore,
            title: "RealStore - Ecommerce Site",
            stacks: [react, redux, js, node, express, mongo, mui, heroku],
            links: { demo: "https://realstore-mern-ecommerce.cyclic.app/", github: "https://github.com/Sudhanshu894/realstore-ecommerce-website" },
            desc: "It's an Ecommerce Web application where user can find, select, filter and purchase from any products available to their likings. But as any other website user have to register first to purchase or add products to their cart. This website is fully responsive for mobile, tablets, laptops. etc. with minimal and simple design theme to make it easy to surf and user interactive.",
        },
        {
            name: "Twitter Clone",
            subtitle: "Social Media",
            heroimg: twitter,
            title: "Twitter Clone",
            stacks: [react, js, netlify],
            links: { github: "https://github.com/Sudhanshu894/Twitter_Clone", demo: "https://twitter-project-work.netlify.app/" },
            desc: "An Social Media Platform Which Provide Us The Enviornment To Share Our Experience Through Posting Media Stories Which All Others Can Give Their Opinions Or Ideas Via Comment And Like The Post Also And User Can Delete Their Post As Well If Want."
        },
        {
            name: "Youtube Clone",
            subtitle: "OTT Platform",
            heroimg: youtube,
            title: "Youtube Clone",
            stacks: [html, css, js, netlify],
            links: { demo: "https://youtube-clone-ss.netlify.app/", github: "https://github.com/Sudhanshu894/Youtube-Clone-app" },
            desc: "An Social Media Platform And Multimedia Platform Integrated With Deboucing In Search Bar, Videos On Recommendation And Fetching And Manupulating The Data Through APIs."
        },
        {
            name: "Beminimalist Clone",
            subtitle: "Ecommerce",
            heroimg: beminimalist,
            title: "Beminimalist Clone",
            stacks: [html, css, js, node, mongo, express, heroku],
            links: { demo: "https://beminimalist-clone-website.herokuapp.com/", github: "https://github.com/Sudhanshu894/Beminimalist-Clone-website" },
            desc: "This is a minimalist type website that makes the user give more attention to the products and contents. This site comes with great UI/UX design simply. The minimalist site comes with great animation which makes it a more user interactive website. This site provides Clean Beauty products that are free from well-researched toxins and does not sensitize your skin - irrespective of their natural or naturally derived tag. Basically, minimalist websites have great animation with a simplistic design."
        }
    ]

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        window.addEventListener("scroll", scrollActive);
    }, [scrollActive])

    useEffect(() => {
        AOS.init({
            delay: 1000,
        });
        AOS.refresh();
    }, [])

    const dialogtitleStyle = {
        backgroundColor: `var(--body-color)`,
        fontFamily: `var(--title-font)`,
    }

    const dialogContentstyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        backgroundColor: 'var(--body-color)',
    }

    const textStyle = {
        color: 'var(--title-color)',
        padding: '1rem',
    }
    return (
        <>
            <ProjectStyles className='section' id='projects' ref={currref}>
                <h2 className="section__title">Projects</h2>
                <span className="section__subtitle">My Works</span>

                <div className="container section__border">
                    <Swiper
                        loop={true}
                        spaceBetween={24}
                        navigation={true}
                        pagination={true}
                        breakpoints={{
                            1200: {
                                slidesPerView: 2,
                                spaceBetween: -56,
                            }
                        }}
                        mousewheel={true}
                        keyboard={true}
                        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                        className="projects__container">
                        <div className="swiper-wrapper" data-aos="fade-up">

                            {projects?.map((project, ind) => {
                                return <SwiperSlide className='projects__content'>
                                    <SingleProject key={ind} heroimg={project.heroimg} name={project.name} subtitle={project.subtitle} item={project} setTitle={setTitle} setDesc={setDesc} setPimg={setPimg} setLinks={setLinks} setStacks={setStacks} handleClickOpen={handleClickOpen} />
                                </SwiperSlide>
                            })}

                        </div>
                    </Swiper>
                </div>
            </ProjectStyles>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                className='dialog'

            >
                <DialogTitle id="responsive-dialog-title" className='dialog__title' style={dialogtitleStyle}>
                    {title}
                </DialogTitle>
                <DialogContent style={dialogContentstyle} className="dialog__content">
                    <img src={pimg} style={{
                        width: '75%',
                        alignSelf: 'center',
                        margin: '1rem 0',
                        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                        padding: '1rem',
                        borderRadius: '1rem',
                    }} />
                    <DialogContentText style={textStyle}>
                        {desc}
                    </DialogContentText>
                    <Box style={{
                        display: 'flex',
                        gap: '1.5rem',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: "center",
                    }} className="dialog__content-stacks">
                        {stacks.map((el, ind) => {
                            return <img key={ind} src={el} style={{
                                width: '45px',
                                height: '45px',
                            }} />
                        })}
                    </Box>
                    <Box className='dialog__actions-btn' style={{
                        display: 'flex',
                        gap: '1rem',
                        margin: '1.5rem auto 0 auto',
                    }}>
                        <Button style={{
                            backgroundColor: 'var(--title-light)',
                            padding: '0.5rem 1rem',
                            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px 0px',

                        }}>
                            <a href={links.demo} style={{
                                color: 'var(--title-color)',
                                fontWeight: '500',
                                fontSize: '0.8rem',
                                fontFamily: 'var(--body-font)',
                            }} target="_blank">Demo Link</a>
                        </Button>
                        <Button style={{
                            backgroundColor: 'var(--title-light)',
                            padding: '0.5rem 1rem',
                            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px 0px',

                        }}>
                            <a style={{
                                color: 'var(--title-color)',
                                fontWeight: '500',
                                fontSize: '0.8rem',
                                fontFamily: 'var(--body-font)',
                            }} href={links.github} target="_blank">Repo Link</a>

                        </Button>
                    </Box>
                </DialogContent>
                <DialogActions style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '2rem',
                    backgroundColor: 'var(--body-color)',
                }} className="dialog__actions">
                    <Button onClick={handleClose} style={{
                        backgroundColor: 'var(--title-light)',
                        padding: '0.5rem 1rem',
                        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px 0px',
                        fontSize: '0.8rem',
                        fontFamily: 'var(--body-font)',

                    }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Project